import { Component, Input, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogOptions } from '@lib/util';
import {
    PurchaseRequisitionProcessDisplayComponent,
    PurchaseRequisitionProcessDisplayData,
} from '../purchase-requisition-process-display/purchase-requisition-process-display.component';

@Component({
    selector: 'purchase-requisition-process-display-button',
    templateUrl: './purchase-requisition-process-display-button.component.html',
    styleUrls: ['./purchase-requisition-process-display-button.component.scss'],
    standalone: false
})
export class PurchaseRequisitionProcessDisplayButtonComponent {
    private readonly dialog = inject(MatDialog);

    @Input() public purchaseRequisitionId?: string;
    @Input() public purchaseRequisitionNumber?: string;

    public openDialog(): void {
        if (this.purchaseRequisitionId && this.purchaseRequisitionNumber) {
            this.dialog.open(
                PurchaseRequisitionProcessDisplayComponent,
                DialogOptions.LARGE(
                    new PurchaseRequisitionProcessDisplayData(
                        this.purchaseRequisitionId,
                        this.purchaseRequisitionNumber
                    )
                )
            );
        }
    }
}
